import type { CSSProperties } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { palette, spacing, transition } from '../../styles/tokens';
import type { SortControls } from '../../hooks/useSortState';

interface SortableHeaderProps {
  column: string;
  label: string;
  sort: SortControls;
  align?: 'left' | 'right' | 'center';
  style?: CSSProperties;
}

export function SortableHeader({ column, label, sort, align = 'left', style }: SortableHeaderProps) {
  const isActive = sort.column === column;
  const dir = isActive ? sort.direction : null;

  return (
    <th
      onClick={() => sort.toggleSort(column)}
      style={{
        textAlign: align,
        padding: `${spacing.sm}px ${spacing.md}px`,
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: isActive ? palette.g900 : palette.g400,
        borderBottom: `1px solid ${palette.g150}`,
        cursor: 'pointer',
        userSelect: 'none',
        transition: `color ${transition.fast}`,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
      }}>
        {label}
        {isActive && dir === 'asc' && <ChevronUp size={12} />}
        {isActive && dir === 'desc' && <ChevronDown size={12} />}
      </span>
    </th>
  );
}
